export default __webpack_public_path__ + "static/media/review.6e649e68.svg";